import script from "./MobileTab3.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileTab3.vue?vue&type=script&setup=true&lang=ts"

import "./MobileTab3.vue?vue&type=style&index=0&id=2cfbedc2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cfbedc2"]])

export default __exports__